import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.replace";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { reactive } from '@vue/composition-api';
import axios from '@/services/axios';
;
;
;
var inviteShareData = reactive({
  result: 0,
  headUrl: '',
  nickName: '',
  inviteCode: '',
  awardList: [],
  reward: 0,
  isGolds: false,
  unit: '',
  isEnded: false,
  activityReward: 0
});

var fetchData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(params) {
    var res, _res$data$headUrl, _res$data, _res$data2, _res$data3, _res$data4, _res$data4$threshold, _res$data5, _res$data6, _res$data7, _res$data$isEnded, _res$data8, _res$data9;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get('/rest/w/promotion/task/boost/landing', {
              params: params
            });

          case 2:
            res = _context.sent;
            inviteShareData.result = res.result;

            if (inviteShareData.result === 1) {
              inviteShareData.headUrl = String((_res$data$headUrl = (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.headUrl) !== null && _res$data$headUrl !== void 0 ? _res$data$headUrl : '').replace('http:', '');
              inviteShareData.nickName = ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.nickName) || '';
              inviteShareData.inviteCode = ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.inviteCode) || '';
              inviteShareData.awardList = ((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$threshold = _res$data4.threshold) === null || _res$data4$threshold === void 0 ? void 0 : _res$data4$threshold.awardList) || [];
              inviteShareData.reward = ((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.reward) || 0;
              inviteShareData.isGolds = ((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.rewardType) === 1;
              inviteShareData.unit = (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.unit;
              inviteShareData.isEnded = (_res$data$isEnded = (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.isEnded) !== null && _res$data$isEnded !== void 0 ? _res$data$isEnded : false;
              inviteShareData.activityReward = ((_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.activityReward) || 0;
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchData(_x) {
    return _ref.apply(this, arguments);
  };
}();

export { inviteShareData, fetchData };